/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, string, func, oneOfType, shape, elementType, number, arrayOf,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import ImageEditor from './ImageEditor/ImageEditor';
import CustomsMessageView from './CustomsMessageView';
import SelectPersonalizeImage from './ImageEditor/SelectPersonalizeImage';

const styles = (theme) => ({
    selectCustomsContainer: {
        margin: '1.875rem 0px',
        display: 'flex',
        justifyContent: 'center',
    },
    contentContainer: {
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
    },
    selectedImage: {
        width: '100%',
        height: '100%',
    },
    imageContent: {
        height: '100%',
        width: '45%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    messageContentParent: {
        width: '45%',
        padding: '0.313rem 0.313rem 0.313rem 0px',
    },
    messageContent: {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        border: `2px dotted ${theme.palette.cgc?.grey || '#a4a4a4'}`,
    },
});
const PersonalizeImageAndMessageCustoms = ({
    classes, image,  handleImage, message, setMessage, setImage, customCardStyling,
    imagePreviewCanvasRef,  imgHeight, imgWidth, csLabelData, toolbarProps,
    customCardType,
}) => {
    const mobileResolution = useMediaQuery('(max-width: 600px)'); // for mobile resolution

    const { message_width, image_width } = customCardStyling || {};
    const calcDimension = (val) => (val * 72) / 300;
    const messageWidth = calcDimension(mobileResolution && message_width > 450 ? (message_width / 2) : message_width);
    const imageWidth = calcDimension(mobileResolution && image_width > 450 ? (image_width / 2) : image_width);
    return (
        <>
            <Grid container className={classes.contentContainer}>
                <Grid
                    className={classes.imageContent}
                    style={{
                        width: `${imageWidth}px`,
                    }}
                >

                    {!image
                        ?                    (
                            <SelectPersonalizeImage handleImage={handleImage} />
                        )
                        :  (
                            <ImageEditor
                                image64={image}
                                setImage={setImage}
                                imgWidth={imgWidth}
                                imgHeight={imgHeight}
                                imagePreviewCanvasRef={imagePreviewCanvasRef}
                            />
                        ) }
                </Grid>
                <Grid
                    style={{
                        width: `${messageWidth}px`,
                        marginLeft: `${customCardStyling?.space_between_message_image}px`,
                    }}
                    className={classes.messageContentParent}
                >
                    <CustomsMessageView
                        messageData={message}
                        setCardMessage={setMessage}
                        csLabelData={csLabelData}
                        toolbarProps={toolbarProps}
                        customCardType={customCardType}
                    />
                </Grid>
            </Grid>
        </>
    );
};

PersonalizeImageAndMessageCustoms.propTypes = {
    classes: object.isRequired,
    image: string.isRequired,
    handleImage: func.isRequired,
    message: string.isRequired,
    setMessage: func.isRequired,
    setImage: func.isRequired,
    customCardStyling: shape({
        image_width: number.isRequired,
        message_width: number.isRequired,
        space_between_message_image: number.isRequired,
    }).isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    imgWidth: number.isRequired,
    imgHeight: number.isRequired,
    csLabelData: shape({
        message_settings: shape({
            heading_font_size: string,
        }),
    }).isRequired,
    toolbarProps: arrayOf(shape({
        value: string,
        label: string,
        icon: string,
        title: string,
        type: string,
        list: arrayOf(shape({
            label: string,
            value: string,
        })),
    })),
    customCardType: string.isRequired,
};
PersonalizeImageAndMessageCustoms.defaultProps = {
    toolbarProps: {},
};
export default withStyles(styles)(PersonalizeImageAndMessageCustoms);
